import Swal from "sweetalert2";

const config = {
    jobConstants: {
        PENDING: "Pending",
        ACCEPTED: "Accepted",
        PENDING_ON_USER_CONFIRMATION: "Waiting for Customer Confirmation",
        PROGRESS: "Progress",
        COMPLETED: "Completed",
        CANCELLED: "Cancelled",
    },
    // myUrl: "http://127.0.0.1:8000",
    myUrl: "https://home-helper.developer-ourbase-camp.com",
    // myUrl: "http://localhost:3000",
    socialSignins: {
        google: {
            clientId:
                "1038508913866-7h64hut3jq2g9v680miufqm6gbkodduo.apps.googleusercontent.com",
        },
        facebook: {
            clientId: "3434322450146373",
        },
        apple: {
            clientId: "com.myhomehelper.app.web",
        },
    },
    pusher: {
        key: "c9281696a1dbacecd965",
        cluster: "mt1",
    },
    stripePK:
        "pk_test_51KVyJDJ1xTWSgklOBiTUJdG97xFahPbL6OIcZxgtiuBzAWUGDxUzMbQ8g3tYje4w5e3fIH0o4hndWE03o7ibRpIt00wdQKcUtO",
    primaryColor: "#FF5635",
    secondprimaryColor: "#2bcd36",
    starActiveColor: "#FFCC00",
    starInactiveColor: "#C8C8C8",
    // baseUrl: "http://127.0.0.1:8000/api",
    // assetUrl: "http://127.0.0.1:8000",
    baseUrl: "https://home-helper-admin.developer-ourbase-camp.com/api",
    assetUrl: "https://home-helper-admin.developer-ourbase-camp.com/",
    // baseUrl: "http://localhost/home_helper/public/api",
    // assetUrl: "http://localhost/home_helper/public/",
    services: {
        getServices: () => config.baseUrl + "/services",
        allCareGiver: (
            zip = null,
            service_id = null,
            unit = null,
            price_range_from = null,
            price_range_to = null,
            rating = null,
            date_range_from = null,
            date_range_to = null
        ) =>
        `${config.baseUrl}/care-giver/all?location=${zip}&service_id=${service_id}&unit=${unit}&price_range_from=${price_range_from}&price_range_to=${price_range_to}&rating=${rating}&date_range_from=${date_range_from}&date_range_to=${date_range_to}`,

        login: () => config.baseUrl + "/auth/login",
        register: () => config.baseUrl + "/auth/register",
        updateProfile: () => config.baseUrl + "/user/update",
        customerBookings: (status = null) =>
            config.baseUrl + "/job/showUserJob?status=" + status,
        careGiverBookings: (status = null) =>
            config.baseUrl + "/job/showGiverJob?status=" + status,
        singleJob: (id) => config.baseUrl + "/job/show/" + id,
        startJob: (job_id, schedule_id) =>
            `${config.baseUrl}/job/startJob/${job_id}/${schedule_id}`,
        startJobCustomer: (job_id, schedule_id) =>
            `${config.baseUrl}/job/startJobCustomer/${job_id}/${schedule_id}`,
        acceptJob: (job_id, schedule_id) =>
            `${config.baseUrl}/job/acceptJob/${job_id}/${schedule_id}`,
        cancelScheduleJob: (job_id, schedule_id) =>
            `${config.baseUrl}/job/cancelScheduleJob/${job_id}/${schedule_id}`,
        cancelJob: (job_id) => `${config.baseUrl}/job/cancelJob/${job_id}`,
        endJob: (job_id, schedule_id) =>
            `${config.baseUrl}/job/endJobByCareGiver/${job_id}/${schedule_id}`,
        favorite: () => `${config.baseUrl}/favorites`,
        singleCareGiver: (id) => `${config.baseUrl}/care-giver/${id}`,
        bookJob: () => `${config.baseUrl}/job/store`,
        careGiverStep1: () => `${config.baseUrl}/care-giver/add-services`,
        careGiverStep2: () => `${config.baseUrl}/care-giver/update-services`,
        careGiverStep3: () => `${config.baseUrl}/care-giver/createProfile`,
        deleteService: (id) =>
            `${config.baseUrl}/care-giver/delete-service/${id}`,
        addCard: () => `${config.baseUrl}/payment/storeCard`,
        states: () => `${config.baseUrl}/setting/showState`,
        getPaymentMethods: () => `${config.baseUrl}/payment/showCard`,
        removeCard: () => `${config.baseUrl}/payment/removeCard`,
        updateDefaultCard: () => `${config.baseUrl}/payment/updateDefaultCard`,
        changePassword: () => `${config.baseUrl}/user/changePassword`,
        getChat: () => `${config.baseUrl}/chat/show`,
        getMessages: () => `${config.baseUrl}/chat/getMessages`,
        sendMessage: () => `${config.baseUrl}/chat/store`,
        notifications: () => `${config.baseUrl}/notification/show`,
        readNotifications: () => `${config.baseUrl}/notification/read-all`,
        socialLogin: () => `${config.baseUrl}/auth/social-login`,
        updateService: (id) =>
            `${config.baseUrl}/care-giver/update-service/${id}`,
        forgotPassword: () => `${config.baseUrl}/auth/sendCode`,
        verifyCode: () => `${config.baseUrl}/auth/checkCode`,
        resetPassword: () => `${config.baseUrl}/auth/resetPassword`,
        resendEmail: () => `${config.baseUrl}/auth/resend-email`,
        rate: () => `${config.baseUrl}/rating/store`,
        newsletter: () => `${config.baseUrl}/setting/newsLetterStore`,
        allServicesMeta: () => `${config.baseUrl}/services-meta`,
        servicesMeta: (service_id) =>
            `${config.baseUrl}/services-meta/${service_id}`,
        walletHistory: () => `${config.baseUrl}/wallet-history`,
        updateTime: (job_id, schedule_id) =>
            `${config.baseUrl}/job/changeVisitTime/${job_id}/${schedule_id}`,
        userInfo: () => `${config.baseUrl}/user/info`,
        pages: () => `${config.baseUrl}/setting/showPage`,
        documments: () => `${config.baseUrl}/documents`,
    },
    defaultHeaders : {
        "Content-Type": "application/json",
        Accept: "application/json",
    },
    bearerHeaders: (token) => {
        return {
            "Content-Type": "application/json",
            Accept: "application/json",
            Authorization: "Bearer " + token,
        };
    },
    multipartBearerHeaders: (token) => {
        return {
            // "Content-Type":
            // "multipart/form-data; charset=utf-8; boundary=" +
            // Math.random().toString().substr(2),
            Accept: "application/json",
            Authorization: "Bearer " + token,
        };
    },
    getApi: async (url, headers) => {
        try {
            const res = await fetch(url, { headers });
            const resJson = await res.json();
            if (resJson.status == true) {
                return resJson;
            } else {
                if (typeof resJson.errors == "string") {
                    if (resJson.errors) {
                        Swal.fire({
                            icon: "error",
                            title: "Oh Snap :(",
                            html:
                                "Something went wrong, Please check below<br/><strong>" +
                                resJson.errors +
                                "</strong>",
                        });
                        throw Error(resJson.errors);
                    } else {
                        Swal.fire({
                            icon: "error",
                            title: "Oh Snap :(",
                            html:
                                "Something went wrong, Please check below<br/><strong>" +
                                resJson.message +
                                "</strong>",
                        });
                        throw Error(resJson.message);
                    }
                }
                else if (typeof resJson.errors == "object") {
                    let error = "";
                    Object.keys(resJson.errors).map((field) => {
                        if (typeof resJson[field] == "object") {
                            resJson.errors[field].map((singleError) => {
                                error += `${"<br/>" + singleError + "<br/>"}`;
                            });
                        } else {
                            error += `${resJson.errors[field]}`;
                        }
                    });
                    if (resJson.errors.length == 0) {
                        error = resJson.message;
                    }
                    // console.log(error);
                    if (error == "You Must Verify Your Email") {
                    } else {
                        Swal.fire({
                            icon: "error",
                            title: "Oh Snap :(",
                            html:
                                "Something went wrong, Please check below<br/><strong>" +
                                error +
                                "</strong>",
                        });
                    }
                    throw Error(error);
                }
                console.log(resJson.message);
            }
        } catch (e) {
            console.log(e);
        }
    },
    postApi: async (url, headers, data, email = null) => {
        try {
            const res = await fetch(url, {
                headers,
                body: data,
                method: "POST",
            });
            const resJson = await res.json();
            if (resJson.status == true) {
                return resJson;
            } else {
                if (typeof resJson.errors == "string") {
                    if (resJson.errors) {
                        Swal.fire({
                            icon: "error",
                            title: "Oh Snap :(",
                            html:
                                "Something went wrong, Please check below<br/><strong>" +
                                resJson.errors +
                                "</strong>",
                        });
                        throw Error(resJson.errors);
                    } else {
                        Swal.fire({
                            icon: "error",
                            title: "Oh Snap :(",
                            html:
                                "Something went wrong, Please check below<br/><strong>" +
                                resJson.message +
                                "</strong>",
                        });
                        throw Error(resJson.message);
                    }
                } else if (typeof resJson.errors == "object") {
                    let error = "";
                    Object.keys(resJson.errors).map((field) => {
                        if (typeof resJson[field] == "object") {
                            resJson.errors[field].map((singleError) => {
                                error += `${"<br/>" + singleError}`;
                            });
                        } else {
                            error += `<br/>${resJson.errors[field]}`;
                        }
                    });
                    if (resJson.errors.length == 0) {
                        error = resJson.message;
                    }
                    if (error == "You Must Verify Your Email") {
                    } else {
                        Swal.fire({
                            icon: "error",
                            title: "Oh Snap :(",
                            html:
                                "Something went wrong, Please check below<br/><strong>" +
                                error +
                                "</strong>",
                        });
                    }
                    throw Error(error);
                }
                // console.log(resJson);
                // console.log(resJson.message);
            }
        } catch (e) {
            throw Error(e.message);
        }
    },
    deleteApi: async (url, headers, email = null) => {
        try {
            const res = await fetch(url, {
                headers,
                method: "DELETE",
            });
            const resJson = await res.json();
            if (resJson.status == true) {
                return resJson;
            } else {
                if (typeof resJson.errors == "string") {
                    if (resJson.errors) {
                        Swal.fire({
                            icon: "error",
                            title: "Oh Snap :(",
                            html:
                                "Something went wrong, Please check below<br/><strong>" +
                                resJson.errors +
                                "</strong>",
                        });
                        throw Error(resJson.errors);
                    } else {
                        Swal.fire({
                            icon: "error",
                            title: "Oh Snap :(",
                            html:
                                "Something went wrong, Please check below<br/><strong>" +
                                resJson.message +
                                "</strong>",
                        });
                        throw Error(resJson.message);
                    }
                } else if (typeof resJson.errors == "object") {
                    let error = "";
                    Object.keys(resJson.errors).map((field) => {
                        if (typeof resJson[field] == "object") {
                            resJson.errors[field].map((singleError) => {
                                error += `${"<br/>" + singleError}`;
                            });
                        } else {
                            error += `<br/>${resJson.errors[field]}`;
                        }
                    });
                    if (resJson.errors.length == 0) {
                        error = resJson.message;
                    }
                    if (error == "You Must Verify Your Email") {
                    } else {
                        Swal.fire({
                            icon: "error",
                            title: "Oh Snap :(",
                            html:
                                "Something went wrong, Please check below<br/><strong>" +
                                error +
                                "</strong>",
                        });
                    }
                    throw Error(error);
                }
                // console.log(resJson);
                // console.log(resJson.message);
            }
        } catch (e) {
            throw Error(e.message);
        }
    },
    returnImage: (user) => {
        let anotherUser = { ...user };
        let picture = "";
        if (anotherUser) {
            if (anotherUser.profile_picture) {
                if (anotherUser.profile_picture.toString().includes("http")) {
                    picture = anotherUser.profile_picture;
                } else {
                    picture = `${config.assetUrl}/${anotherUser.profile_picture}`;
                }
            } else {
                picture = `https://ui-avatars.com/api/?name=${anotherUser.first_name}+${anotherUser.last_name}&size=256&background=random`;
            }
        } else {
            picture = `https://ui-avatars.com/api/?name=Home+Helper&size=256&background=random`;
        }
        return picture;
    },
    mapsApiKey: "AIzaSyBZnicWbv_MEYIHQWGBP0G4uYwsqXl3mqk",
    hideEmail: (email) => {
        return email.replace(/(.{2})(.*)(?=@)/, function (gp1, gp2, gp3) {
            for (let i = 0; i < gp3.length; i++) {
                gp2 += "*";
            }
            return gp2;
        });
    },
    caiptalize: (strr) => {
        let str1 = strr.toString().charAt(0).toUpperCase() + strr.slice(1);
        return str1;
    },
    monthsYearsFormatter: (number) => {
        if (number > 0 && number < 1) {
            return number * 10 + " Months";
        } else {
            return parseInt(number).toString() + " Year(s)";
        }
    },
};

export default config;
